import React from 'react';
import generateLeavePDF from './generateLeavePDF';

const summaryColumns = [
  'Financial Year',
  'Leave Type',
  'Total Leave',
  'Leave Taken',
  'Remaining',
];

const detailColumns = [
  'Employee Name',
  'Financial Year',
  'Leave Type',
  'Leave Date',
  // 'Remarks',
];

const LeaveTable = ({ leaveData, name = 'All', startDate, endDate }) => {
  // console.log("data-->>>", leaveData)
  // console.log("dateStart", startDate)
  // console.log("dateEnd", endDate)
  //  Fixed: Properly closed formatDateRange function
  const formatDateRange = (start, end) => {
    return `${start} to ${end}`;
  };

  //  Group data by financial year
  const totalsByYear = leaveData?.reduce((acc, item) => {
    const year = item.FINANCIAL_YEAR;
    if (!acc[year]) {
      acc[year] = {
        totalLeave: 0,
        taken: 0,
        remaining: 0,
      };
    }
    acc[year].totalLeave += item.TOTAL_LEAVE;
    acc[year].taken += item.TAKEN;
    acc[year].remaining += item?.TOTAL_LEAVE - item?.TAKEN;
    return acc;
  }, {});

  //  Expand LEAVE_DATES and extract REMARKS
  const expandedData =
    leaveData?.flatMap((item) =>
      item.LEAVE_DATES?.split(',')?.map((date) => {
        const match = date?.trim()?.match(/^([^\(]+)\s*(\(.*\))?$/);

        const leaveDate = match ? match[1]?.trim() : date?.trim();
        const remarks = match && match[2] ? match[2].slice(1, -1) : '';

        return {
          ...item,
          LEAVE_DATE: leaveDate,
          REMARKS: remarks,
        };
      }) || [] // handle if split gives undefined
    ) || [];

  const sortedData = expandedData?.sort((a, b) => {
    const dateA = new Date(a.LEAVE_DATE);
    const dateB = new Date(b.LEAVE_DATE);
    return dateA - dateB;
  });
  const handleDownload = () => {
    const selectedDateRange = formatDateRange(startDate, endDate);
    // console.log("range", selectedDateRange)
    generateLeavePDF({ leaveData, name, selectedDateRange });
  };
  // console.log("summaryColumns--->>>>>",sortedData)
  return (
    <div className="font-[sans-serif] max-w-full mx-auto p-4 sm:p-6 md:p-8">

      <span className='flex justify-end'>
        <button
          onClick={handleDownload}
          className="mb-4 rounded-md  bg-primaryPurple px-4 py-2 text-sm font-semibold text-white hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
        >
          Download PDF
        </button>
      </span>

      <div className="bg-white rounded-lg shadow-lg p-4 sm:p-6 md:p-8 overflow-x-auto">
        {/* Financial Year Summary */}
        <div className="mb-8">
          <h3 className="text-2xl font-semibold text-gray-800 mb-4 sm:mb-6">Leave Summary</h3>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border-separate border-spacing-0 rounded-lg shadow-sm summary-table">
              <thead>
                <tr className="bg-primaryPurple text-white whitespace-nowrap">
                  {summaryColumns.map((item, index) => (
                    <th
                      key={index}
                      className={`border-b border-gray-200 px-3 py-3 text-center text-sm font-semibold ${index === 0 ? 'rounded-tl-lg' : ''} ${index === summaryColumns.length - 1 ? 'rounded-tr-lg' : ''}`}
                    >
                      {item}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {leaveData &&
                  leaveData.reduce((rows, item, index) => {
                    const year = item.FINANCIAL_YEAR;
                    // Add the data row
                    rows.push(
                      <tr key={`data-${index}`} className="hover:bg-gray-50 transition-colors">
                        <td className="border-b border-gray-200 px-3 py-2 text-center text-gray-700 text-sm">
                          {item.FINANCIAL_YEAR}
                        </td>
                        <td className="border-b border-gray-200 px-3 py-3 text-center text-gray-700 text-sm">
                          {item.LEAVE_TYPE}
                        </td>
                        <td className="border-b border-gray-200 px-3 py-3 text-center text-gray-700 text-sm">
                          {item.TOTAL_LEAVE}
                        </td>
                        <td className="border-b border-gray-200 px-3 py-3 text-center text-gray-700 text-sm">
                          {item.TAKEN}
                        </td>
                        <td
                          className={`border-b border-gray-200 px-4 py-3 text-center text-sm ${item.TOTAL_LEAVE - item.TAKEN < 0
                              ? 'text-red-600 font-medium'
                              : item.REMAINING > 0
                                ? 'text-green-600 font-medium'
                                : 'text-gray-700'
                            }`}
                        >
                          {item.TOTAL_LEAVE - item.TAKEN}
                        </td>
                      </tr>
                    );

                    // Check if this is the last item for the current financial year
                    const isLastItemForYear =
                      index === leaveData.length - 1 || leaveData[index + 1]?.FINANCIAL_YEAR !== year;
                    if (isLastItemForYear && totalsByYear[year]) {
                      // Add total row for the financial year
                      rows.push(
                        <tr key={`total-${year}`} className="bg-gray-200 font-semibold">
                          <td className="border-b border-gray-200 px-3 py-3 text-center text-gray-800 text-sm font-semibold">
                            Total for {year}
                          </td>
                          <td className="border-b border-gray-200 px-3 py-3 text-center text-gray-800 text-sm">-</td>
                          <td className="border-b border-gray-200 px-3 py-3 text-center text-gray-800 text-sm">
                            {totalsByYear[year].totalLeave}
                          </td>
                          <td className="border-b border-gray-200 px-3 py-3 text-center text-gray-800 text-sm">
                            {totalsByYear[year].taken}
                          </td>
                          <td
                            className={`border-b border-gray-200 px-4 py-3 text-center text-sm ${totalsByYear[year].remaining < 0
                                ? 'text-red-600 font-medium'
                                : totalsByYear[year].remaining > 0
                                  ? 'text-green-600 font-medium'
                                  : 'text-gray-800'
                              }`}
                          >
                            {totalsByYear[year].remaining}
                          </td>
                        </tr>
                      );
                    }

                    return rows;
                  }, [])}
              </tbody>
            </table>
          </div>
        </div>

        {/* Leave Summary Details Heading */}
        <h2 className="text-2xl font-semibold text-gray-800 mb-4 sm:mb-6">Leave Summary Details</h2>

        {/* Detailed Leave Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border-separate border-spacing-0 rounded-lg shadow-sm details-table">
            <thead>
              <tr className="bg-primaryPurple text-white whitespace-nowrap">
                {detailColumns?.map((item, index) => (
                  <th
                    key={index}
                    className={`border-b border-gray-200 px-3 py-3 text-center text-sm font-semibold ${index === 0 ? 'rounded-tl-lg' : ''} ${index === detailColumns.length - 1 ? 'rounded-tr-lg' : ''}`}
                  >
                    {item}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sortedData?.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50 transition-colors">
                  <td className="border-b border-gray-200 px-3 py-3 text-center text-gray-700 text-sm">
                    {item.EMPLOYEE_NAME}
                  </td>
                  <td className="border-b border-gray-200 px-3 py-3 text-center text-gray-700 text-sm">
                    {item.FINANCIAL_YEAR}
                  </td>
                  <td className="border-b border-gray-200 px-3 py-3 text-center text-gray-700 text-sm">
                    {item.LEAVE_TYPE}
                  </td>
                  <td className="border-b border-gray-200 px-3 py-3 text-center text-gray-700 text-sm">
                    {item.LEAVE_DATE}
                  </td>
                  {/* <td className="border-b border-gray-200 px-3 py-3 text-center text-gray-700 text-sm">
                    {item?.REMARKS}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LeaveTable;